var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.33317V4.6665C4 2.45736 5.79086 0.666504 8 0.666504C10.2091 0.666504 12 2.45736 12 4.6665V5.33317H13.3333C13.7015 5.33317 14 5.63165 14 5.99984V13.9998C14 14.368 13.7015 14.6665 13.3333 14.6665H2.66667C2.29848 14.6665 2 14.368 2 13.9998V5.99984C2 5.63165 2.29848 5.33317 2.66667 5.33317H4ZM12.6667 6.6665H3.33333V13.3332H12.6667V6.6665ZM7.33333 10.4881C6.9348 10.2576 6.66667 9.8267 6.66667 9.33317C6.66667 8.59677 7.2636 7.99984 8 7.99984C8.7364 7.99984 9.33333 8.59677 9.33333 9.33317C9.33333 9.8267 9.0652 10.2576 8.66667 10.4881V11.9998H7.33333V10.4881ZM5.33333 5.33317H10.6667V4.6665C10.6667 3.19374 9.47273 1.99984 8 1.99984C6.52724 1.99984 5.33333 3.19374 5.33333 4.6665V5.33317Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c3dd2e0e928e5d786c78dfac0e04adc2.svg";
export { ForwardRef as ReactComponent };